import useSWR, { type Fetcher } from 'swr'
import { client } from '~/api/client'
import { Schemas, getMemberByUserName } from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'

export const fetchGetMemberByUserName: Fetcher<
  Schemas.member_large_detail,
  [operation: 'getMemberByUserName', userName: string]
> = async ([, userName]) => {
  const res = await getMemberByUserName(client, {
    parameter: { user_name: userName },
  })
  assertSuccess(res)
  return res.data
}

export const useMember = (
  userName: string
): Schemas.member_large_detail | undefined => {
  const res = useSWR<
    Schemas.member_large_detail,
    Error,
    [operation: 'getMemberByUserName', userName: string]
  >(['getMemberByUserName', userName], fetchGetMemberByUserName)
  return res.data
}
